import { combineReducers } from 'redux'
import {
    REKAPPO, REKAPPODETAIL
} from '../actions/reportRekapPoAction'

const FetchDataPOAll = (state = { isLoad: false, data: { data: [] } }, action) => {
    switch (action.type) {
        case REKAPPO:
            return { isload: action.load, data: action.data }
        default:
            return state
    }
}

const FetchDataDetailPOAll = (state = { isLoad: false, data: [] }, action) => {
    switch (action.type) {
        case REKAPPODETAIL:
            return { isload: action.load, data: action.data }
        default:
            return state
    }
}

const RekapPoReducer = combineReducers({
    FetchDataPOAll,
    FetchDataDetailPOAll
})

export default RekapPoReducer